import Modal from 'react-bootstrap/Modal';

import 'components/LM/common/Drawer.scss';

function Drawer(props) {
	const {show, title, children} = props;
	const { onClose} = props;

	return (
		<Modal
			show={show}
			className='drawer right-align'
			size='xl'
		>
			<Modal.Header onHide={onClose}>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{children}
			</Modal.Body>
		</Modal>
	);
}

export default Drawer;
